module.exports = __webpack_public_path__ + "static/media/gradient-bg.b8f6bae3.png";